import React from 'react';

import EmailInput from '../../../form-components/email-input';
import ErrorMessage from '../../../form-components/error-message';

export default ({
  // Data values
  emailValue,
  setEmailValue,

  // Validation
  formValid,
  validationMessage
}) => (
  <div>
    <EmailInput emailValue={emailValue} setEmailValue={setEmailValue} />

    {!formValid && (
      <ErrorMessage
        title="Form not complete for submission"
        message={validationMessage}
      />
    )}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/contribution-form/forms/new-item-form/stage-5/index.js